export class OrderSlTpBase {
    constructor() {
        this.value = null; // null - value awaits for recalculation
        this.offsetType = null; // null - absolute value
        this.enabled = false;
        this.error = null;
    }
}
